import { createSelector } from 'reselect'
import createCardIdsSelector from 'routes/Board/selectors/createCardIdsSelector'

export const getDueDate = (state, props) => {
  return state['view-board'].cards[props.cardContext.id].dueDate
}

export const getStartDate = (state, props) => {
  return state['view-board'].cards[props.cardContext.id].startDate
}

export const getCardRelations = (state, props) => {
  return state.kanbo.cardRelations.byId[props.id]
}

const getCardsById = (state, props) => {
  return state['view-board'].cards
}

const getBoardId = (state, props) => state['view-board'].cards[props.cardContext.id].boardId

const createCalendarDateSelector = () => {
  const cardIdsSelector = createCardIdsSelector(getBoardId)

  return createSelector(
    [getCardRelations, getCardsById, cardIdsSelector, getStartDate],
    (cardRelations, cardsById, cardIds, startDate) => {
      if (cardRelations && !startDate) {
        const allParents = cardRelations.parentIds.map(String)
        const localParents = allParents.filter(parent => cardIds.includes(parent))

        if (localParents.length === 1 && cardsById[localParents[0]]) {
          const parent = cardsById[localParents[0]]
          return parent.startDate ? parent.startDate : (parent.dueDate ? parent.dueDate : null)
        } else {
          return null
        }
      } else {
        return startDate ? startDate : null
      }
    }
  )
}

export default () => {
  const calendarDateSelector = createCalendarDateSelector()

  return createSelector(
    [
      getDueDate,
      getStartDate,
      calendarDateSelector
    ],
    (
      dueDate,
      startDate,
      calendarDate
    ) => ({
      dueDate,
      startDate,
      calendarDate
    })
  )
}
